import { render, staticRenderFns } from "./TrustList.vue?vue&type=template&id=378c8b50&"
import script from "./TrustList.vue?vue&type=script&lang=js&"
export * from "./TrustList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports